import { useTranslation, Trans } from 'next-i18next'

export default function SDKSafeguardError() {
  const { t } = useTranslation()

  return (
    <div style={{ background: 'white', padding: 48, margin: 48 }}>
      <Trans i18nKey="SDKSafeguardError.installError" t={t}>
        Install Error: Please ensure you&apos;ve installed the campaign correctly using the
        instructions{' '}
        <a
          href="http://idonthavealinkforthisyet.gov/"
          title={t('SDKSafeguardError.linkTitle', 'How to install Classy Embedded?')}
        >
          here
        </a>
      </Trans>
    </div>
  )
}
